import { render, staticRenderFns } from "./GlobalLayoutSub.vue?vue&type=template&id=19767c8f&"
import script from "./GlobalLayoutSub.vue?vue&type=script&lang=js&"
export * from "./GlobalLayoutSub.vue?vue&type=script&lang=js&"
import style0 from "./GlobalLayoutSub.vue?vue&type=style&index=0&id=19767c8f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports